<template lang="html">
  <div id="Main">
    <div class="background" />
    <div class="info">
      <el-row class="fadeIn" type="flex" justify="center">
        <el-col>
          <h1 class="title">GENTLE MAP은 지도 제작 플랫폼입니다.</h1>
          <div class="content">
            <p>Excel 데이터 파싱을 통한 지도 생성</p>
            <p>팀 수에 맞춘 마커 분할</p>
            <p>실시간 진행상황 동기화</p>
            <p>모바일 반응형 웹 & GPS 지원</p>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <hr class="center-bar">
      </el-row>
      <el-row class="action slideDown" type="flex" justify="center">
        <button class="demoLink" @click="demoLink">DEMO</button>
      </el-row>
      <el-row class="action slideDown" type="flex" justify="center">
        <button class="createProjectBtn" @click="createProject">프로젝트 지도 만들기</button>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Main',
  metaInfo: {
    title: '지도 제작 플랫폼',
    titleTemplate: 'Gentle Map | %s'
  },
  data: () => ({
    demo: '/projects/uid_1133538575/pid_1570264238683?pw=1234'
  }),
  methods: {
    createProject() {
      this.$router.push('/create')
    },
    startAnim() {
      this.descriptionAnim01 = true
    },
    demoLink() {
      this.$router.push(this.demo)
    }
  }
}

</script>
<style lang="scss" scoped>
#Main {
  display: flex;
  height: 100%;
  margin-top: 15vh;
  align-items: center;

  .info {
    z-index: 100;
    margin: auto;
    text-align: center;
    padding: 8px;

    .title {
      font-size: 2.0rem;
      margin-bottom: 50px;
      color: white;
    }

    .content {
      font-size: 1.5rem;
    }

    p {
      color: white;
      margin-bottom: 20px;
    }

    .action button{
      width: 300px;
      font-size: 1.5rem;
      padding: 10px;
      background: transparent;
      color: white;
      border: 1px solid white;
      border-radius: 3px;
      margin: auto;
      cursor: pointer;
      margin-bottom: 16px;
    }

    .demoLink {
      margin-bottom: 16px;
    }

    .center-bar {
      width: 30px;
      height: 2px;
      margin: 80px 0px;
    }

    .createProjectBtn:hover,
    .demoLink:hover {
      background-color: var(--accent-color);
    }
  }

  .background {
    background-image: url('../../assets/main_background.png');
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    background-position: center;
    background-size: cover;
  }
}

/* Mobile */
@media only screen and (max-width : 768px) {
  #Main {

    .info {
      margin-top: 0px;

      .center-bar {
        margin: 30px 0px;
      }

      .createProjectBtn {
        width: 100%;
        margin: 8px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/index.vue